import { render, staticRenderFns } from "./lottery-winner.vue?vue&type=template&id=229353cc&"
import script from "./lottery-winner.vue?vue&type=script&lang=js&"
export * from "./lottery-winner.vue?vue&type=script&lang=js&"
import style0 from "./lottery-winner.vue?vue&type=style&index=0&id=229353cc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports